import React from 'react'
import styled from '@emotion/styled'
import Icon from 'components/patterns/Icon'
import strings from 'utils/strings'

const FlexCenterDiv = styled.div`
  display: flex;
  align-items: center;
`

const AuthorizationHeaderSpan = styled.span`
  width: 335px;
  height: 32px;
  font-family: Arial;
  font-size: 36px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.89;
  letter-spacing: -0.5px;
  color: #0c5b78;
  margin-left: 12px;
`

const StyledFooterDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const Header = () => (
  <FlexCenterDiv>
    <Icon icon="chec_logo_color" className="chec_logo_color-icon" />
    <AuthorizationHeaderSpan>
      {strings.chec_authorization}
    </AuthorizationHeaderSpan>
  </FlexCenterDiv>
)

export const Content = () => (
  <div>
    <p>{strings.unauthorized_user_message[0]}</p>
    <p>{strings.unauthorized_user_message[1]}</p>
  </div>
)

export const Footer = () => (
  <StyledFooterDiv>
    <a href="https://www.dtnaarc.com/daimler/perfCtr/campus/frameset/frameset.jsp">
      {strings.access_arc}
      <Icon icon="FaChevronRight" />
    </a>
  </StyledFooterDiv>
)

const AuthorizationError = () => (
  <div className="body">
    <div className="header">
      <Header />
    </div>
    <div className="content">
      <Content />
    </div>
    <div className="footer">
      <Footer />
    </div>
  </div>
)

export default AuthorizationError
